// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"qU-z","inlineTitle":"rU-z","sponsoredAdsWrapper":"sU-z","marketplaceRecosWrapper":"tU-z"};